export const breedList = [
	{
		pk: 'a14334ea-74e2-40e9-ba98-db14b7860303',
		name: 'American Buckskin-ABRA',
	},
	{
		pk: 'fe69824c-af2a-4da0-a80f-08570eace57c',
		name: 'American Brindle Equine Association',
	},
	{
		pk: 'f4a64f2a-c21a-4893-a71e-e131dec496cd',
		name: 'American Appendix (AAHA)',
	},
	{
		pk: 'dfe47830-84eb-4e2e-9ff8-974f35cd0141',
		name: 'Alpaca',
	},
	{
		pk: 'f17fdc5c-d2dc-4ca7-9759-33a3258a2760',
		name: 'Akhal-Teke',
	},
	{
		pk: '572ade25-02a4-49db-a0e9-ff64ace1118e',
		name: 'American Cream Draft Horse',
	},
	{
		pk: 'e166a6fc-b0b1-4c8b-a80c-375c6e1dcbc0',
		name: 'American Creme and White (Albino)',
	},
	{
		pk: 'e7dc66ff-ec9e-4096-b283-e0da3d1c4cc0',
		name: 'American Dartmoor Pony',
	},
	{
		pk: 'db8d1de3-fae1-4d90-9370-074092a094a7',
		name: 'American Gaited Endurance Horse',
	},
	{
		pk: '781ce178-db66-48d6-8ad7-cfed05a9b005',
		name: 'American Indian Horse Registry',
	},
	{
		pk: 'f37e7eae-2b22-48af-9122-c05103ccc6b4',
		name: 'American Paint Pony',
	},
	{
		pk: '2ce434d0-3f63-410a-bcc7-d0b111978190',
		name: 'American Polo Horse',
	},
	{
		pk: '2a9f0629-6558-4f64-bc52-92b71aca61b8',
		name: 'American Ranch Horse Association',
	},
	{
		pk: '12441271-8f30-406c-b14e-bf52ed352c5b',
		name: 'American Saddlebred',
	},
	{
		pk: '2ca74764-2291-40be-827b-255949d4e713',
		name: 'American Show Pony',
	},
	{
		pk: '76e57bb8-68b6-4394-bcec-69b5cd304868',
		name: 'American Sport Pony',
	},
	{
		pk: 'b7f99714-3654-4719-80e1-71485552ccbc',
		name: 'American Sulphur Horse',
	},
	{
		pk: 'a5ccb89f-3b6d-40b5-9e60-fe29a36dc41a',
		name: 'American Warmblood Registry',
	},
	{
		pk: '4eeffd4c-2521-451a-a75d-6c66a688cd6b',
		name: 'American Warmblood Society',
	},
	{
		pk: 'e8f2dce5-d660-45ee-8006-f39d8409ae2f',
		name: 'Andalusian',
	},
	{
		pk: 'c0016bca-b2f7-4aed-ab59-516ad57fa470',
		name: 'Andalusian Cross',
	},
	{
		pk: '999d9a17-2f73-4314-b3c9-6a4f646df48c',
		name: 'APHA-Paint',
	},
	{
		pk: 'cd99bf81-b78b-4730-999e-df0055f220bc',
		name: 'Appalachian Singlefoot',
	},
	{
		pk: '004f49df-2f1f-4f41-af52-f691dd135fda',
		name: 'Appaloosa',
	},
	{
		pk: '8d581fc9-fd63-4473-a8a3-1e1d5c7e1d5e',
		name: 'AQHA Quarter Horse',
	},
	{
		pk: 'e42fe2bf-33a4-4a53-b94a-aadb5266aa52',
		name: 'AQHA Quarter Horse Appendix',
	},
	{
		pk: '3c5182cc-ba83-4cb4-bfda-3cca2d25893b',
		name: 'AQHA Quarter Horse CROSS',
	},
	{
		pk: '050430f7-02f5-4fb8-aa2a-6778ec334139',
		name: 'AraAppaloosa',
	},
	{
		pk: '0bb33ddf-f9f1-4d9f-933d-5092b7227a20',
		name: 'Arabian',
	},
	{
		pk: 'fd0ab707-86e8-426b-a068-cf73b3ce9604',
		name: '"Arabian, Shagya"',
	},
	{
		pk: '9c64dc48-8a2e-4c85-a791-7c5828d95b01',
		name: 'Arabian-Anglo',
	},
	{
		pk: 'd0e45027-ab6d-4ece-98c5-889f00376068',
		name: 'Arabian-CROSS',
	},
	{
		pk: '2299681f-ea05-43f1-8ac9-022741d75c60',
		name: 'Arabian-HALF',
	},
	{
		pk: 'f560cdc9-b640-408a-9976-a9382ceceb3c',
		name: 'Arabian-Pinto',
	},
	{
		pk: 'd1d15173-4fa2-4694-9b96-220f4aa626a1',
		name: 'Arabian-Saddlebred',
	},
	{
		pk: '183ad0db-b845-4df4-9ad5-2a088288e733',
		name: 'Arabian-TB CROSS',
	},
	{
		pk: '03b69a93-b206-4bc7-84c5-74870c20ea46',
		name: 'Argentine Criollo',
	},
	{
		pk: 'cb42dc50-7fac-4804-a134-f4bd641b7d45',
		name: 'Australian Stock Horse',
	},
	{
		pk: '4a4d91e2-0dc4-4375-be40-cfd54ae4d403',
		name: 'Australian Warmblood',
	},
	{
		pk: '11332104-a2a1-4986-ab85-b4b688f5c93c',
		name: 'Azteca',
	},
	{
		pk: 'a8f433bf-b64f-4db7-a0a9-a78ae015a609',
		name: 'Bashkir Curly',
	},
	{
		pk: 'f8fc0bca-fd23-4a7c-aec3-81e03461ea26',
		name: 'Bavarian Warmblood',
	},
	{
		pk: 'e7b50d27-13e4-462c-899d-0aa966f11dc3',
		name: 'Belgian',
	},
	{
		pk: '88be6ad1-e143-45e0-b345-6991ee29b356',
		name: 'Belgian Sporthorse',
	},
	{
		pk: 'f575f464-b55e-4a84-9800-3bdf1bf6c79e',
		name: 'Belgian Warmblood',
	},
	{
		pk: '7acac29e-3c72-427a-b0c6-c86195ab98eb',
		name: 'Black Forest Horse',
	},
	{
		pk: '61078955-ca67-4bce-8ee1-5c70715e4ab8',
		name: 'Blazer',
	},
	{
		pk: 'a5838a98-4ae2-4c5b-8ece-d4d0a235fd1f',
		name: 'Blue Eyed Horse Association',
	},
	{
		pk: '3786e3f4-9b3c-4e05-8732-84636a6ea03e',
		name: 'Brandenburger',
	},
	{
		pk: '265534a9-6b74-4a5e-9478-dd1b7f60c92b',
		name: 'Budyonny',
	},
	{
		pk: 'db9ed739-e63c-451e-8959-1509ffc1bb64',
		name: 'Canadian CROSS',
	},
	{
		pk: '0a99f6cc-e43f-4705-bedd-b59172b7e555',
		name: 'Canadian Horse',
	},
	{
		pk: '905f6d95-b627-4151-a8d8-e7e9aa793369',
		name: 'Canadian Sport Horse',
	},
	{
		pk: '958a9432-b60e-4652-9f9c-6455834965b7',
		name: 'Canadian Warmblood',
	},
	{
		pk: 'b28ff713-b513-4834-b900-22d7021cfe47',
		name: 'Caspian Horse',
	},
	{
		pk: '13d471c6-a1e4-4930-a2ac-799571c05839',
		name: 'Champagne Horse-CHBOA',
	},
	{
		pk: 'ac375e80-6728-4ded-970a-070887bd30b8',
		name: 'Champagne Horse-ICHR',
	},
	{
		pk: 'ae0b904b-6208-4938-93a2-196f7bbfe6d5',
		name: 'Chincoteague Pony',
	},
	{
		pk: 'c7063c44-5155-4996-b337-dd1dec183afe',
		name: 'Cleveland Bay',
	},
	{
		pk: '6ad1834c-4a55-45c6-97da-0ca9aa4479ce',
		name: 'Clydesdale',
	},
	{
		pk: '4840d8c1-7909-4ebc-ab3f-c28a3318f194',
		name: 'Colonial Spanish Horse',
	},
	{
		pk: '95129c2f-8fa7-4001-9187-fa0536465a99',
		name: 'Colorado Rangerbred',
	},
	{
		pk: 'f7b07379-dc7c-4560-a4cf-c6e5335c6368',
		name: 'Connemara',
	},
	{
		pk: '501dfcd6-b473-41c7-8d77-37623dffce74',
		name: 'Czech Warmblood',
	},
	{
		pk: 'b8ee03c7-6bb1-4aa9-9845-1c557ce807e0',
		name: 'Dales Pony',
	},
	{
		pk: '14401d47-2e2c-4376-889c-9876ecfd18ea',
		name: 'Danish Warmblood',
	},
	{
		pk: 'e0af8f98-69a3-4d53-823d-d19fca17c0da',
		name: 'Dartmoor Pony',
	},
	{
		pk: 'e6116642-82ca-410e-b120-9d85ed2dfdd3',
		name: 'Donkey',
	},
	{
		pk: '45086d43-9179-4d48-8685-470b752d630c',
		name: 'Donkey - Mammoth',
	},
	{
		pk: 'f5e8d498-db6c-49fc-b2a2-838127ff7281',
		name: 'Donkey - Miniature',
	},
	{
		pk: '1bbc5605-d45c-46dd-a62c-b4070bcc1c92',
		name: 'Draft',
	},
	{
		pk: 'e72d0b81-5b05-4dcc-878d-c75e55864d64',
		name: 'Draft CROSS',
	},
	{
		pk: '6e23c179-7465-4a65-81c9-5457c27eb7df',
		name: 'Drum Horse',
	},
	{
		pk: 'cd439b0f-dd4e-4b20-8fa5-3508e0b2d847',
		name: 'Dutch Harness Horse',
	},
	{
		pk: '89ee93d3-2cee-4528-a571-f67656b5b1b2',
		name: 'Dutch Warmblood',
	},
	{
		pk: '0cec4eb4-fcca-4f01-8708-385f419350b2',
		name: 'Fell Pony',
	},
	{
		pk: '3b5d15d2-680c-4fd6-8405-79ca4c11c0b4',
		name: 'Fjord',
	},
	{
		pk: 'ae5d83a9-8906-46fa-bcf9-329bb7c1c3b5',
		name: 'Florida Cracker Horse',
	},
	{
		pk: '4084f47c-360b-42e2-b3e4-05d579905a1f',
		name: 'Foundation Quarter Horse Registry-FQHR',
	},
	{
		pk: '559c5840-8ff4-447b-812b-f909d7cdd592',
		name: 'Frederiksborg',
	},
	{
		pk: 'ef62cfcd-a71e-4338-8824-4b11c3ce5662',
		name: 'Friesian',
	},
	{
		pk: '12ad1d50-2bcb-4c99-a46a-b74993a4c363',
		name: 'Friesian Cross',
	},
	{
		pk: '594f7fee-e81f-48cc-bab8-5303669a05a9',
		name: 'Galiceno',
	},
	{
		pk: '83024d4f-ae8c-46d1-bf85-8c5070eae725',
		name: 'German Riding Pony',
	},
	{
		pk: '9a438a24-037a-41da-8055-1db50127fb48',
		name: 'German Warmblood',
	},
	{
		pk: '58e2d189-e680-4ca4-9471-92d1eea3c426',
		name: 'Goat',
	},
	{
		pk: '7e5dbb1c-e58e-4e36-a9b1-74f888b62c79',
		name: 'Grade',
	},
	{
		pk: 'dd3779bb-456b-4c0b-a152-fea309cafcc0',
		name: 'Gypsy Cob',
	},
	{
		pk: 'cb827dcc-0571-4f0e-ae8b-23de76662273',
		name: 'Gypsy Cross',
	},
	{
		pk: 'af89e445-2498-4442-8f6e-f84f9da88d5a',
		name: 'Gypsy Vanner',
	},
	{
		pk: 'f27a3d00-fcd2-4b0c-80e3-97fd05cd1251',
		name: 'Hackney Horse',
	},
	{
		pk: 'ddd90e59-444e-4a75-ba13-2e0e220819df',
		name: 'Hackney Pony',
	},
	{
		pk: '7b3849ce-2c71-4777-aad7-58efbcf728b9',
		name: 'Haflinger',
	},
	{
		pk: 'da806023-fb60-40db-a533-f7a7c0706399',
		name: 'Hanoverian',
	},
	{
		pk: '4a9acbd6-c75a-44ad-b877-f31f8d93c471',
		name: 'Hessen',
	},
	{
		pk: '93970da8-60aa-42aa-a800-b27f8a84ab00',
		name: 'Highland Pony',
	},
	{
		pk: '8dbde010-e464-4811-aa31-34a4506d263c',
		name: 'Hinny',
	},
	{
		pk: 'e0591a0e-a959-4f90-baa9-83282889b20f',
		name: 'Holsteiner',
	},
	{
		pk: '9064f22a-b1fc-4a59-aa47-5fae7a67d0b5',
		name: 'Hungarian Warmblood',
	},
	{
		pk: '3b0ce639-2bc1-477e-a39c-f00af7223b8b',
		name: 'Iberian Warmblood',
	},
	{
		pk: 'c274d76a-2081-4be8-92e2-06b3d6a51730',
		name: 'Icelandic',
	},
	{
		pk: '6b6c3e9d-e8cd-4560-88bf-2873de720dca',
		name: 'International Buckskin-IBHA',
	},
	{
		pk: '894e53ab-281c-4a2a-b670-d0c2fc1c0316',
		name: 'International Sporthorse',
	},
	{
		pk: 'f6b0af45-11cb-4d5d-9854-d609baa2f5ac',
		name: 'Irish Cob',
	},
	{
		pk: 'cf973e66-df42-4071-ac30-7964f8d67826',
		name: 'Irish Draught',
	},
	{
		pk: 'a1e75f1a-60ba-4ef7-be92-ffe5fdbb8d65',
		name: 'Irish Sport Horse',
	},
	{
		pk: '2fd6b6e6-9725-477a-bdff-ef8572b7c612',
		name: 'Kentucky Mountain',
	},
	{
		pk: '97309aa9-4c4b-4863-822b-44e63b4f54f7',
		name: 'Kerry Bog Pony',
	},
	{
		pk: '5c586aff-f911-4fbf-9166-a3564e326b67',
		name: 'Kiger Mustang',
	},
	{
		pk: '259ce5aa-8605-45b5-863f-33688220a8c0',
		name: 'Kladruby Horse',
	},
	{
		pk: 'aa059c04-aa97-4903-8997-c6135dbb189d',
		name: 'Knabstrupper',
	},
	{
		pk: '6f643118-472d-4656-8e8f-5acbf966a6e4',
		name: 'Lipizzan',
	},
	{
		pk: 'a25129c6-cce4-4311-9a38-72c4f02fe5d9',
		name: 'Llama',
	},
	{
		pk: '45155bc6-4812-4d01-9c92-c4edcbeb7004',
		name: 'Lusitano',
	},
	{
		pk: 'ef3e848e-ada4-4966-b139-3ffc5c5b8ae9',
		name: 'Mangalarga Marchador',
	},
	{
		pk: '27027172-9ebc-43da-9597-1a9c28a345d3',
		name: 'Mangalarga Paulista',
	},
	{
		pk: 'b2a1bdbf-a1a9-44cc-8034-ce91f97bde9e',
		name: 'McCurdy Plantation Horse',
	},
	{
		pk: '1dc7f91f-1178-4ecb-bfdf-1d164ce522ad',
		name: 'Miniature',
	},
	{
		pk: '34e61f88-1d37-4661-8526-4b7ca94abb6c',
		name: 'Missouri Fox Trotter Horse',
	},
	{
		pk: 'ab9c1cc0-b45a-47dc-90c7-012f36783128',
		name: 'Missouri Fox Trotter Pony',
	},
	{
		pk: '7660b631-b698-4336-9741-bb17af3c3899',
		name: 'Montana Travler',
	},
	{
		pk: 'a8324785-778c-4fd9-ae37-d23cf8006784',
		name: 'Morab',
	},
	{
		pk: '536335cd-4858-4fb3-8b69-6ca20508e15b',
		name: 'Morgan',
	},
	{
		pk: '19aab179-55bf-49ac-9aa0-4390cd65d152',
		name: 'Morocco Spotted Horse',
	},
	{
		pk: 'a3e42a30-eec4-4e28-b662-7fddc17b2079',
		name: 'Mountain Pleasure Horse',
	},
	{
		pk: '062cfff8-8b3c-46dd-9c60-99b2ff0a7b66',
		name: 'Mule',
	},
	{
		pk: '0af26a67-dd17-42ec-8f7b-26887649f324',
		name: 'Mule - Mammoth',
	},
	{
		pk: 'ec2e42da-26fc-4127-b241-14c3ae422666',
		name: 'Mule - Miniature',
	},
	{
		pk: '91719982-82e2-46ee-94b5-700b570f3aee',
		name: 'Mustang',
	},
	{
		pk: 'c362fa41-d2fa-4e7d-a244-93e5945c81eb',
		name: 'Nambian Warmblood',
	},
	{
		pk: 'c7c88ead-b1fa-47bb-a0d4-a5c3e2fa47b0',
		name: 'National Quarter Horse Registry',
	},
	{
		pk: 'ca2e9cfa-3891-46bd-8630-ef9b72d48e17',
		name: 'National Show Horse',
	},
	{
		pk: 'ead33a2a-e60a-4a51-8cab-0046246df65e',
		name: 'Natl Foundation Quarter Horse-NFQHA',
	},
	{
		pk: 'dda6167e-4d59-4c75-a527-661cd84d25e6',
		name: 'New Forest Pony',
	},
	{
		pk: 'ef6e3cd2-3d2c-40e5-b706-41deff70196d',
		name: 'New Zealand Warmblood',
	},
	{
		pk: 'bfa8ad2d-cf8e-414d-a939-ee2a06397c9e',
		name: 'Newfoundland Pony',
	},
	{
		pk: '79c3fd5b-b74c-4a79-8c09-f0921b5e2809',
		name: 'Nez Perce Horse',
	},
	{
		pk: 'bdcdd9b9-5e5a-4d23-879a-9deadf3994ce',
		name: 'Nokota',
	},
	{
		pk: 'd58cd669-7558-4a7b-ba55-39b1b84a0537',
		name: 'Noric',
	},
	{
		pk: '18f520cf-a988-4be3-a55a-99b5f519f4d4',
		name: 'Oberlander Draft Horse',
	},
	{
		pk: 'eeec05ea-7618-492c-b3a0-24686c0aaa03',
		name: 'Oldenburg',
	},
	{
		pk: '194334f7-7a51-47c1-82ea-7772fb6274dd',
		name: 'Orlov-Rostopchin',
	},
	{
		pk: 'e448cffa-4698-4cfa-81de-2703f2db3740',
		name: 'Other',
	},
	{
		pk: '3a742870-55ae-4a03-a124-b6d102c12523',
		name: 'Palomino Horse Breed Assn - PHBA',
	},
	{
		pk: 'bcccc94a-273f-4b04-a040-90fce527d237',
		name: 'Paso Fino',
	},
	{
		pk: '33a40a8f-804d-42c1-ba54-bcd368147c12',
		name: 'Percheron',
	},
	{
		pk: 'b46f0bbd-81b2-40c8-9b10-5d2100c70b10',
		name: 'Peruvian Paso',
	},
	{
		pk: 'b1c32bf7-9e19-4353-9fc4-1465fab8e5f7',
		name: 'Pintabian',
	},
	{
		pk: 'd128dd20-eaa8-4745-837a-d699e7fd17b7',
		name: 'Pintaloosa',
	},
	{
		pk: '9a2fb188-f7c9-4968-925d-bcd962daa7ef',
		name: 'Pinto',
	},
	{
		pk: '66c131c4-9a77-4518-bbad-553284b452f1',
		name: 'Pinto Paso',
	},
	{
		pk: '1b1b45da-0b3a-4e53-b1e1-12b1e02f3585',
		name: 'Pleasure Saddle Horse Registry',
	},
	{
		pk: '8a29f52d-0554-4bc6-a159-3a990ea4c253',
		name: 'POA',
	},
	{
		pk: '1f03c564-b04d-4f38-9d9f-e4e0a889287d',
		name: 'Polish Warmblood (Wielkopolski)',
	},
	{
		pk: 'bd24715a-dea8-4a90-9a33-71a266abc668',
		name: 'Pony',
	},
	{
		pk: 'eea4c25c-a886-4cad-94ed-d966420216e1',
		name: 'PRE Mundial',
	},
	{
		pk: 'c4d32a18-cb7c-4174-93fc-78ed6cee9efe',
		name: 'Pura Raza Espanola',
	},
	{
		pk: '140ffedb-4649-46b8-930c-43168db1b9bc',
		name: 'Quarab',
	},
	{
		pk: '9a9a13ba-9858-491c-9099-dfc3df464f28',
		name: 'Quarter Pony',
	},
	{
		pk: '7e2f921e-fbaa-40b4-818c-8cdb7e83dd57',
		name: 'Racking Horse',
	},
	{
		pk: '9975d5b3-e2b3-4047-89eb-1267eeed7b07',
		name: 'Rheinland-Pfalz-Saar',
	},
	{
		pk: '6e63b64f-64b2-4fd9-8f4c-aa3199a7a7f6',
		name: 'Rocky Mountain',
	},
	{
		pk: '2041f2b5-449a-4346-8501-251fe219ad0b',
		name: 'Schwartzwalder Fuchs',
	},
	{
		pk: '415cfb45-29ef-4f47-b9e3-930dd877aca4',
		name: 'Selle Francais',
	},
	{
		pk: 'f88353d2-d3fe-4aab-9ead-8f4a0c598eb2',
		name: 'Shetland Pony',
	},
	{
		pk: 'ce4eada6-762d-4b50-b64e-2f6724afee79',
		name: 'Shire',
	},
	{
		pk: '29daf8f8-47b9-42be-9f95-8da1ae889475',
		name: 'Singlefoot',
	},
	{
		pk: 'fe6765e6-bc1f-48ee-937a-bab81c7bb63e',
		name: 'South African Warmblood',
	},
	{
		pk: 'af5f7e19-07f0-407a-a8d3-9fd48f86f779',
		name: 'Spanish Barb',
	},
	{
		pk: 'a9b8d8f3-02bd-4fda-9a49-08f748e34502',
		name: 'Spanish Jennet',
	},
	{
		pk: '6be01725-5c39-4db7-8d99-a00ef3c28568',
		name: 'Spanish Mustang',
	},
	{
		pk: '4a5b3853-3bdd-442b-bd28-5a555b79ac3e',
		name: 'Spanish Norman',
	},
	{
		pk: '47b04f01-1186-4e5b-b971-3221c94ffc1c',
		name: 'Sport Horse of Color',
	},
	{
		pk: '9f730394-154e-4a78-8b40-880e5d592eed',
		name: 'Spotted Draft',
	},
	{
		pk: '2923cafe-2483-46a5-a17a-818b8badd6f5',
		name: 'Spotted Mountain Horse',
	},
	{
		pk: '8ebcfcfd-d4ab-47d4-8b48-d7c99a5a65fc',
		name: 'Spotted Saddle',
	},
	{
		pk: '080e075b-036a-40c2-a9db-68c8918229fe',
		name: 'Standard Quarter-SQHA',
	},
	{
		pk: '44cd3e54-7d5a-4aea-8196-d1c25d314181',
		name: 'Standardbred',
	},
	{
		pk: 'ff6d645f-07b7-4a52-a96a-fd158823f941',
		name: 'Steer (riding)',
	},
	{
		pk: '56591d73-bd97-40af-95f5-791b8fddc7e8',
		name: 'Suffolk',
	},
	{
		pk: 'd26b5b01-bf81-460b-a489-2bbc3c33a965',
		name: 'Swedish Gotland',
	},
	{
		pk: '793bf3e6-838f-48b2-b077-c983502ff432',
		name: 'Swedish Warmblood',
	},
	{
		pk: '0ee6d875-1001-4a13-b3bb-016fbc50016c',
		name: 'Swiss Warmblood',
	},
	{
		pk: 'c693e200-73ee-4303-ade3-27b14ef6382e',
		name: 'Tennessee Walker',
	},
	{
		pk: '32f3ff5d-9995-481e-bce2-338c1f960813',
		name: 'Tennuvian',
	},
	{
		pk: '16d31f2a-2d6b-4331-beb9-88ba31f131dd',
		name: 'Thoroughbred',
	},
	{
		pk: 'f0a4190f-e6d5-40fd-8ade-948284c40e85',
		name: 'Thoroughbred CROSS',
	},
	{
		pk: 'cfc10cca-0579-4498-9462-8e8f96d103e1',
		name: 'Thoroughbred-Welsh CROSS',
	},
	{
		pk: 'de3701e6-d414-47ae-b739-0b398e2d66f3',
		name: 'Tigre Horse',
	},
	{
		pk: '9e027e5b-f4b9-48a7-a5b3-81791f3dd55a',
		name: 'Trakehner',
	},
	{
		pk: 'cb301906-b332-474f-ae96-a0581fdb5fe2',
		name: 'Trote y Galope',
	},
	{
		pk: '477208cb-f106-4f1e-b5fe-e0e81082559a',
		name: 'United Mountain Horse',
	},
	{
		pk: '322fc40a-0fb1-4137-b7d3-d4e68765b884',
		name: 'Virginia Highlander',
	},
	{
		pk: '808d30f7-1831-4330-a728-c9d5fdf8cb13',
		name: 'Walkaloosa',
	},
	{
		pk: 'f5d4bc5f-e267-418b-9e09-2e5deaeb3a4d',
		name: 'Walking Pony',
	},
	{
		pk: 'cced34ff-5dfa-4c5a-9e2f-5de6d41814b3',
		name: 'Warlander',
	},
	{
		pk: '1c7bbe3e-9741-4473-9eca-5ee0eea91883',
		name: 'Warmblood Cross',
	},
	{
		pk: '8650c771-32c6-4c95-9e0e-37e5f45d6ac4',
		name: 'Warmbloods of Color',
	},
	{
		pk: '42f49c25-5552-4570-ac90-fa7ba7b13224',
		name: 'Welara Pony',
	},
	{
		pk: '5d585eff-fa1c-462d-aae6-c4ed0dae56b4',
		name: 'Welsh Cob',
	},
	{
		pk: '611510a3-4db1-45ca-8065-cc1931798990',
		name: 'Welsh Pony',
	},
	{
		pk: '6adcd8d9-d3e8-4d2a-b5bd-c9473bf02eb2',
		name: 'Westphalian',
	},
	{
		pk: 'cebf7ad0-adc6-420a-bc6f-ec2eb730dba5',
		name: 'Zangersheide',
	},
	{
		pk: '7c3abc28-5dfe-4dc1-b589-a737811ba17a',
		name: 'Zebra',
	},
	{
		pk: '4a8697ef-708e-49f1-ad0a-5243174917eb',
		name: 'Zonkey',
	},
	{
		pk: '816f0eff-3c6a-44c1-8977-3f6b31d3184f',
		name: 'Zorse',
	},
];

export const temperamentList = [
	{
		pk: '1db06bf7-23ca-4daf-9c2b-27110dbd6e92',
		name: '1',
		value: 1,
	},
	{
		pk: '801fbb21-b2a6-4cd0-854d-dd60307e3fa4',
		name: '2',
		value: 2,
	},
	{
		pk: '063eb130-b50e-48aa-8754-92ef2c53d4de',
		name: '3',
		value: 3,
	},
	{
		pk: '3c24942c-1501-4b89-abee-a2e9ddf5cb89',
		name: '4',
		value: 4,
	},
	{
		pk: 'aaad30e6-bdde-44a0-bc5b-174ed0ad1be2',
		name: '5',
		value: 5,
	},
	{
		pk: 'f761db9e-f015-4a77-b388-0d736df37b5a',
		name: '6',
		value: 6,
	},
	{
		pk: '0fd3c9c0-632a-4dc8-9016-0286a2ad3cb9',
		name: '7',
		value: 7,
	},
	{
		pk: '0f2541ce-6e83-49c9-983c-f4745d57dbcf',
		name: '8',
		value: 8,
	},
	{
		pk: 'f443ec91-89b2-4cf1-aea5-92361d8e91f7',
		name: '9',
		value: 9,
	},
	{
		pk: '0fa69193-50bb-4c97-844b-32a9cddebeb9',
		name: '10',
		value: 10,
	},
];

export const genderList = [
	{
		name: 'Mare',
		pk: 'mare',
	},
	{
		name: 'Gelding',
		pk: 'gelding',
	},
	{
		name: 'Stallion',
		pk: 'stallion',
	},
	{
		name: 'Filly',
		pk: 'filly',
	},
	{
		name: 'Colt',
		pk: 'colt',
	},
	{
		name: 'Unborn Foal',
		pk: 'unborn_foal',
	},
];
/*
1990
1991
1992
1993
1994
1995
1996
1997
1998
1999
2000
2001
2002
2003
2004
2005
2006
2007
2008
2009
2010
2011
2012
2013
2014
2015
2016
2017
2018
2019
*/

export const yearList = [
	{
		name: '1989',
		pk: '1989',
		value: 1989,
	},
	{
		name: '1990',
		pk: '1990',
		value: 1990,
	},
	{
		name: '1991',
		pk: '1991',
		value: 1991,
	},
	{
		name: '1992',
		pk: '1992',
		value: 1992,
	},
	{
		name: '1993',
		pk: '1993',
		value: 1993,
	},
	{
		name: '1994',
		pk: '1994',
		value: 1994,
	},
	{
		name: '1995',
		pk: '1995',
		value: 1995,
	},
	{
		name: '1996',
		pk: '1996',
		value: 1996,
	},
	{
		name: '1997',
		pk: '1997',
		value: 1997,
	},
	{
		name: '1998',
		pk: '1998',
		value: 1998,
	},
	{
		name: '1999',
		pk: '1999',
		value: 1999,
	},
	{
		name: '2000',
		pk: '2000',
		value: 2000,
	},
	{
		name: '2001',
		pk: '2001',
		value: 2001,
	},
	{
		name: '2002',
		pk: '2002',
		value: 2002,
	},
	{
		name: '2003',
		pk: '2003',
		value: 2003,
	},
	{
		name: '2004',
		pk: '2004',
		value: 2004,
	},
	{
		name: '2005',
		pk: '2005',
		value: 2005,
	},
	{
		name: '2006',
		pk: '2006',
		value: 2006,
	},
	{
		name: '2007',
		pk: '2007',
		value: 2007,
	},
	{
		name: '2008',
		pk: '2008',
		value: 2008,
	},
	{
		name: '2009',
		pk: '2009',
		value: 2009,
	},
	{
		name: '2010',
		pk: '2010',
		value: 2010,
	},
	{
		name: '2011',
		pk: '2011',
		value: 2011,
	},
	{
		name: '2012',
		pk: '2012',
		value: 2012,
	},
	{
		name: '2013',
		pk: '2013',
		value: 2013,
	},
	{
		name: '2014',
		pk: '2014',
		value: 2014,
	},
	{
		name: '2015',
		pk: '2015',
		value: 2015,
	},
	{
		name: '2016',
		pk: '2016',
		value: 2016,
	},
	{
		name: '2017',
		pk: '2017',
		value: 2017,
	},
	{
		name: '2018',
		pk: '2018',
		value: 2018,
	},
	{
		name: '2019',
		pk: '2019',
		value: 2019,
	},
	{
		name: '2020',
		pk: '2020',
		value: 2020,
	},
	{
		name: '2021',
		pk: '2021',
		value: 2021,
	},
	{
		name: '2022',
		pk: '2022',
		value: 2022,
	},
	{
		name: '2023',
		pk: '2023',
		value: 2023,
	},
	{
		name: '2024',
		pk: '2024',
		value: 2024,
	},
	{
		name: '2025',
		pk: '2025',
		value: 2025,
	},
	{
		name: '2026',
		pk: '2026',
		value: 2026,
	},
];

export const conditionList = [
	{
		name: 'New',
		pk: 'new',
	},
	{
		name: 'Like New',
		pk: 'like_new',
	},
	{
		name: 'Very Good',
		pk: 'very_good',
	},
	{
		name: 'Good',
		pk: 'good',
	},
	{
		name: 'Acceptable',
		pk: 'acceptable',
	},
	{
		name: 'Poor',
		pk: 'poor',
	},
];

// Users want to filter by lease/purchase/seeking/lost-stolen/etc
export const saleTypeList = [
	{
		pk: 'sale', // offer
		name: 'For Sale',
	},
	{
		pk: 'lease',
		name: 'For Lease',
	},
	{
		pk: 'trade',
		name: 'May Trade',
	},
	{
		pk: 'adoption',
		name: 'Adoption',
	},
];

export const adTypeList = [
	{
		pk: 'offer',
		name: 'Offered',
	},
	{
		pk: 'wanted',
		name: 'Wanted/ISO',
	},
	{
		pk: 'missing',
		name: 'Missing/Stolen',
	},
];

export const leaseTypeList = [
	{
		pk: 'full',
		name: 'Full Lease',
	},
	{
		pk: 'partial',
		name: 'Partial Lease',
	},
	{
		pk: 'care',
		name: 'Care Lease',
	},
	{
		pk: 'to_own',
		name: 'Lease to Own',
	},
];

// Backend API has:
// sale_type: sale, wanted, missing, stolen, adoption
/*
consider more indepth & accurate organizing:
sale_type should really become "ad_type"
"sale" enum should really be "offer"

ad_type: offer | wanted | missing/stolen
exchange_type: sale | lease | trade | adoption
lease_type: full | partial | care | to-own

@TODO: implement these in the frontend



*/

/*
export const breedList = [
  {"pk":"81","name":"American Buckskin-ABRA"},
  {"pk":"225","name":"American Brindle Equine Association"},
  {"pk":"145","name":"American Appendix (AAHA)"},
  {"pk":"160","name":"Alpaca"},
  {"pk":"67","name":"Akhal-Teke"},
  {"pk":"191","name":"American Cream Draft Horse"},
  {"pk":"10","name":"American Creme and White (Albino)"},
  {"pk":"80","name":"American Dartmoor Pony"},
  {"pk":"209","name":"American Gaited Endurance Horse"},
  {"pk":"194","name":"American Indian Horse Registry"},
  {"pk":"52","name":"American Paint Pony"},
  {"pk":"181","name":"American Polo Horse"},
  {"pk":"167","name":"American Ranch Horse Association"},
  {"pk":"1","name":"American Saddlebred"},
  {"pk":"147","name":"American Show Pony"},
  {"pk":"117","name":"American Sport Pony"},
  {"pk":"142","name":"American Sulphur Horse"},
  {"pk":"195","name":"American Warmblood Registry"},
  {"pk":"49","name":"American Warmblood Society"},
  {"pk":"2","name":"Andalusian"},
  {"pk":"78","name":"Andalusian Cross"},
  {"pk":"61","name":"APHA-Paint"},
  {"pk":"222","name":"Appalachian Singlefoot"},
  {"pk":"3","name":"Appaloosa"},
  {"pk":"39","name":"AQHA Quarter Horse"},
  {"pk":"110","name":"AQHA Quarter Horse Appendix"},
  {"pk":"65","name":"AQHA Quarter Horse CROSS"},
  {"pk":"70","name":"AraAppaloosa"},
  {"pk":"4","name":"Arabian"},
  {"pk":"122","name":"Arabian, Shagya"},
  {"pk":"150","name":"Arabian-Anglo"},
  {"pk":"60","name":"Arabian-CROSS"},
  {"pk":"135","name":"Arabian-HALF"},
  {"pk":"62","name":"Arabian-Pinto"},
  {"pk":"203","name":"Arabian-Saddlebred"},
  {"pk":"63","name":"Arabian-TB CROSS"},
  {"pk":"168","name":"Argentine Criollo"},
  {"pk":"163","name":"Australian Stock Horse"},
  {"pk":"169","name":"Australian Warmblood"},
  {"pk":"5","name":"Azteca"},
  {"pk":"69","name":"Bashkir Curly"},
  {"pk":"170","name":"Bavarian Warmblood"},
  {"pk":"72","name":"Belgian"},
  {"pk":"171","name":"Belgian Sporthorse"},
  {"pk":"90","name":"Belgian Warmblood"},
  {"pk":"215","name":"Black Forest Horse"},
  {"pk":"153","name":"Blazer"},
  {"pk":"178","name":"Blue Eyed Horse Association"},
  {"pk":"164","name":"Brandenburger"},
  {"pk":"74","name":"Budyonny"},
  {"pk":"91","name":"Canadian CROSS"},
  {"pk":"140","name":"Canadian Horse"},
  {"pk":"154","name":"Canadian Sport Horse"},
  {"pk":"134","name":"Canadian Warmblood"},
  {"pk":"94","name":"Caspian Horse"},
  {"pk":"187","name":"Champagne Horse-CHBOA"},
  {"pk":"156","name":"Champagne Horse-ICHR"},
  {"pk":"129","name":"Chincoteague Pony"},
  {"pk":"7","name":"Cleveland Bay"},
  {"pk":"8","name":"Clydesdale"},
  {"pk":"192","name":"Colonial Spanish Horse"},
  {"pk":"89","name":"Colorado Rangerbred"},
  {"pk":"9","name":"Connemara"},
  {"pk":"172","name":"Czech Warmblood"},
  {"pk":"96","name":"Dales Pony"},
  {"pk":"59","name":"Danish Warmblood"},
  {"pk":"189","name":"Dartmoor Pony"},
  {"pk":"11","name":"Donkey"},
  {"pk":"206","name":"Donkey - Mammoth"},
  {"pk":"137","name":"Donkey - Miniature"},
  {"pk":"12","name":"Draft"},
  {"pk":"121","name":"Draft CROSS"},
  {"pk":"197","name":"Drum Horse"},
  {"pk":"193","name":"Dutch Harness Horse"},
  {"pk":"13","name":"Dutch Warmblood"},
  {"pk":"155","name":"Fell Pony"},
  {"pk":"14","name":"Fjord"},
  {"pk":"212","name":"Florida Cracker Horse"},
  {"pk":"124","name":"Foundation Quarter Horse Registry-FQHR"},
  {"pk":"211","name":"Frederiksborg"},
  {"pk":"16","name":"Friesian"},
  {"pk":"132","name":"Friesian Cross"},
  {"pk":"107","name":"Galiceno"},
  {"pk":"166","name":"German Riding Pony"},
  {"pk":"185","name":"German Warmblood"},
  {"pk":"162","name":"Goat"},
  {"pk":"220","name":"Grade"},
  {"pk":"98","name":"Gypsy Cob"},
  {"pk":"199","name":"Gypsy Cross"},
  {"pk":"141","name":"Gypsy Vanner"},
  {"pk":"71","name":"Hackney Horse"},
  {"pk":"143","name":"Hackney Pony"},
  {"pk":"85","name":"Haflinger"},
  {"pk":"17","name":"Hanoverian"},
  {"pk":"159","name":"Hessen"},
  {"pk":"108","name":"Highland Pony"},
  {"pk":"204","name":"Hinny"},
  {"pk":"18","name":"Holsteiner"},
  {"pk":"139","name":"Hungarian Warmblood"},
  {"pk":"138","name":"Iberian Warmblood"},
  {"pk":"19","name":"Icelandic"},
  {"pk":"82","name":"International Buckskin-IBHA"},
  {"pk":"157","name":"International Sporthorse"},
  {"pk":"115","name":"Irish Cob"},
  {"pk":"20","name":"Irish Draught"},
  {"pk":"114","name":"Irish Sport Horse"},
  {"pk":"68","name":"Kentucky Mountain"},
  {"pk":"214","name":"Kerry Bog Pony"},
  {"pk":"87","name":"Kiger Mustang"},
  {"pk":"151","name":"Kladruby Horse"},
  {"pk":"182","name":"Knabstrupper"},
  {"pk":"21","name":"Lipizzan"},
  {"pk":"161","name":"Llama"},
  {"pk":"112","name":"Lusitano"},
  {"pk":"224","name":"Mangalarga Marchador"},
  {"pk":"126","name":"Mangalarga Paulista"},
  {"pk":"116","name":"McCurdy Plantation Horse"},
  {"pk":"22","name":"Miniature"},
  {"pk":"15","name":"Missouri Fox Trotter Horse"},
  {"pk":"201","name":"Missouri Fox Trotter Pony"},
  {"pk":"226","name":"Montana Travler"},
  {"pk":"23","name":"Morab"},
  {"pk":"24","name":"Morgan"},
  {"pk":"148","name":"Morocco Spotted Horse"},
  {"pk":"73","name":"Mountain Pleasure Horse"},
  {"pk":"25","name":"Mule"},
  {"pk":"208","name":"Mule - Mammoth"},
  {"pk":"184","name":"Mule - Miniature"},
  {"pk":"26","name":"Mustang"},
  {"pk":"173","name":"Nambian Warmblood"},
  {"pk":"198","name":"National Quarter Horse Registry"},
  {"pk":"27","name":"National Show Horse"},
  {"pk":"83","name":"Natl Foundation Quarter Horse-NFQHA"},
  {"pk":"146","name":"New Forest Pony"},
  {"pk":"174","name":"New Zealand Warmblood"},
  {"pk":"216","name":"Newfoundland Pony"},
  {"pk":"213","name":"Nez Perce Horse"},
  {"pk":"86","name":"Nokota"},
  {"pk":"202","name":"Noric"},
  {"pk":"217","name":"Oberlander Draft Horse"},
  {"pk":"28","name":"Oldenburg"},
  {"pk":"223","name":"Orlov-Rostopchin"},
  {"pk":"51","name":"Other"},
  {"pk":"58","name":"Palomino Horse Breed Assn - PHBA"},
  {"pk":"33","name":"Paso Fino"},
  {"pk":"34","name":"Percheron"},
  {"pk":"35","name":"Peruvian Paso"},
  {"pk":"97","name":"Pintabian"},
  {"pk":"101","name":"Pintaloosa"},
  {"pk":"37","name":"Pinto"},
  {"pk":"165","name":"Pinto Paso"},
  {"pk":"188","name":"Pleasure Saddle Horse Registry"},
  {"pk":"38","name":"POA"},
  {"pk":"176","name":"Polish Warmblood (Wielkopolski)"},
  {"pk":"36","name":"Pony"},
  {"pk":"210","name":"PRE Mundial"},
  {"pk":"190","name":"Pura Raza Espanola"},
  {"pk":"57","name":"Quarab"},
  {"pk":"53","name":"Quarter Pony"},
  {"pk":"40","name":"Racking Horse"},
  {"pk":"92","name":"Rheinland-Pfalz-Saar"},
  {"pk":"41","name":"Rocky Mountain"},
  {"pk":"180","name":"Schwartzwalder Fuchs"},
  {"pk":"113","name":"Selle Francais"},
  {"pk":"54","name":"Shetland Pony"},
  {"pk":"43","name":"Shire"},
  {"pk":"144","name":"Singlefoot"},
  {"pk":"175","name":"South African Warmblood"},
  {"pk":"106","name":"Spanish Barb"},
  {"pk":"136","name":"Spanish Jennet"},
  {"pk":"56","name":"Spanish Mustang"},
  {"pk":"128","name":"Spanish Norman"},
  {"pk":"125","name":"Sport Horse of Color"},
  {"pk":"93","name":"Spotted Draft"},
  {"pk":"152","name":"Spotted Mountain Horse"},
  {"pk":"44","name":"Spotted Saddle"},
  {"pk":"66","name":"Standard Quarter-SQHA"},
  {"pk":"45","name":"Standardbred"},
  {"pk":"158","name":"Steer (riding)"},
  {"pk":"95","name":"Suffolk"},
  {"pk":"127","name":"Swedish Gotland"},
  {"pk":"76","name":"Swedish Warmblood"},
  {"pk":"177","name":"Swiss Warmblood"},
  {"pk":"46","name":"Tennessee Walker"},
  {"pk":"75","name":"Tennuvian"},
  {"pk":"48","name":"Thoroughbred"},
  {"pk":"64","name":"Thoroughbred CROSS"},
  {"pk":"179","name":"Thoroughbred-Welsh CROSS"},
  {"pk":"79","name":"Tigre Horse"},
  {"pk":"47","name":"Trakehner"},
  {"pk":"218","name":"Trote y Galope"},
  {"pk":"200","name":"United Mountain Horse"},
  {"pk":"111","name":"Virginia Highlander"},
  {"pk":"84","name":"Walkaloosa"},
  {"pk":"133","name":"Walking Pony"},
  {"pk":"186","name":"Warlander"},
  {"pk":"149","name":"Warmblood Cross"},
  {"pk":"100","name":"Warmbloods of Color"},
  {"pk":"183","name":"Welara Pony"},
  {"pk":"88","name":"Welsh Cob"},
  {"pk":"55","name":"Welsh Pony"},
  {"pk":"50","name":"Westphalian"},
  {"pk":"219","name":"Zangersheide"},
  {"pk":"120","name":"Zebra"},
  {"pk":"221","name":"Zonkey"},
  {"pk":"119","name":"Zorse"}
]
*/
/*
export const colorList = [
{
  "name": "Bay Overo",
  "pk": "bay_overo"
},
{
  "name": "Bay Roan",
  "pk": "bay_roan"
},
{
  "name": "Black",
  "pk": "black"
},
{
  "name": "Black Bay",
  "pk": "black_bay"
},
{
  "name": "Black Overo",
  "pk": "black_overo"
},
{
  "name": "Blue Grulla",
  "pk": "blue_grulla"
},
{
  "name": "Blue Roan",
  "pk": "blue_roan"
},
{
  "name": "Brindle",
  "pk": "brindle"
},
{
  "name": "Brown",
  "pk": "brown"
},
{
  "name": "Buckskin",
  "pk": "buckskin"
},
{
  "name": "Buckskin Overo",
  "pk": "buckskin_overo"
},
{
  "name": "Champagne",
  "pk": "champagne"
},
{
  "name": "Chestnut",
  "pk": "chestnut"
},
{
  "name": "Chestnut Overo",
  "pk": "chestnut_overo"
},
{
  "name": "Chocolate",
  "pk": "chocolate"
},
{
  "name": "Cremello",
  "pk": "cremello"
},
{
  "name": "Dun",
  "pk": "dun"
},
{
  "name": "Dun with Black Points",
  "pk": "dun_blk_pts"
},
{
  "name": "Dunalino",
  "pk": "dunalino"
},
{
  "name": "Dunskin",
  "pk": "dunskin"
},
{
  "name": "Grey",
  "pk": "grey"
},
{
  "name": "Grullo",
  "pk": "grullo"
},
{
  "name": "Liver Chestnut",
  "pk": "liver_chestnut"
},
{
  "name": "Other",
  "pk": "other"
},
{
  "name": "Overo",
  "pk": "overo"
},
{
  "name": "Palomino",
  "pk": "palomino"
},
{
  "name": "Piebald",
  "pk": "piebald"
},
{
  "name": "Pearl",
  "pk": "pearl"
},
{
  "name": "Perlino",
  "pk": "perlino"
},
{
  "name": "Pinto",
  "pk": "pinto"
},
{
  "name": "Red Chocolate",
  "pk": "red_chocolate"
},
{
  "name": "Red Dun",
  "pk": "red_dun"
},
{
  "name": "Red Roan",
  "pk": "red_roan"
},
{
  "name": "Roan",
  "pk": "roan"
},
{
  "name": "Sabino",
  "pk": "sabino"
},
{
  "name": "Silver",
  "pk": "silver"
},
{
  "name": "Silver Dapple",
  "pk": "silver_dapple"
},
{
  "name": "Smokey Black",
  "pk": "smokey_black"
},
{
  "name": "Smokey Cream",
  "pk": "smokey_cream"
},
{
  "name": "Sorrel",
  "pk": "sorrel"
},
{
  "name": "Sorrel Overo",
  "pk": "sorrel_overo"
},
{
  "name": "Tobiano",
  "pk": "tobiano"
},
{
  "name": "Tovero",
  "pk": "tovero"
},
{
  "name": "Unknown",
  "pk": "unknown"
},
{
  "name": "White",
  "pk": "white"
}
];
*/

export const colorList = [
	{
		pk: '13a32c62-2c33-456e-9a73-a688404b8621',
		name: 'Bay',
	},
	{
		pk: 'b2d7ae1e-c0a6-4fc8-93d0-e1aa3d3dc2cc',
		name: 'Bay Overo',
	},
	{
		pk: '9b77701c-354f-4402-8111-88b18d667429',
		name: 'Bay Roan',
	},
	{
		pk: 'e314a2c9-9df8-4813-82ea-d35c3d557f1c',
		name: 'Black',
	},
	{
		pk: 'd5a6d2a4-63ee-4238-b5af-5e32d17510ae',
		name: 'Black Bay',
	},
	{
		pk: '48fba7e5-e2a6-42af-bb22-7ab8b6b28117',
		name: 'Black Overo',
	},
	{
		pk: 'dbbebc1d-ef26-4142-b61c-404cc3fd6dce',
		name: 'Blue Grulla',
	},
	{
		pk: '00619d24-62c0-4323-9d05-88f5ae59556f',
		name: 'Blue Roan',
	},
	{
		pk: '2a33ca40-afc8-472c-a952-711610a50093',
		name: 'Brindle',
	},
	{
		pk: 'ad66f625-e72a-4d35-9840-28270042dd8e',
		name: 'Brown',
	},
	{
		pk: 'fb1b478e-d2dc-438b-8e6a-251ea545d2e5',
		name: 'Buckskin',
	},
	{
		pk: 'f72ff30b-0842-43fb-8f41-fb3103d95ef3',
		name: 'Buckskin Overo',
	},
	{
		pk: '998bc771-9a88-4dae-9333-bcade0c88873',
		name: 'Champagne',
	},
	{
		pk: '288b8709-d974-404f-a311-7cad42ab147c',
		name: 'Chestnut',
	},
	{
		pk: '3a06c6d3-87d5-4458-8cde-a56d33d246b2',
		name: 'Chestnut Overo',
	},
	{
		pk: '815ee566-9119-4fe9-b07c-289c87b309e1',
		name: 'Chocolate',
	},
	{
		pk: '91cb0e0a-c217-4561-8532-83c16660a0cf',
		name: 'Cremello',
	},
	{
		pk: '643997ca-5302-48c1-8202-ac392ac93bfc',
		name: 'Dun',
	},
	{
		pk: 'ac1460fd-f885-4e84-9dc5-4ea54c17b361',
		name: 'Dun with Black Points',
	},
	{
		pk: 'b3a5dffd-5cde-43fc-bc42-dbc151d4476c',
		name: 'Dunalino',
	},
	{
		pk: '8752dc26-af91-4acc-abcc-ec6d68c9f49c',
		name: 'Dunskin',
	},
	{
		pk: '8ada5702-dd50-4ad0-83be-2f6663a8f7d8',
		name: 'Grey',
	},
	{
		pk: '6f6c4e34-bb9e-47d3-8bc9-560638b3e5ee',
		name: 'Grullo',
	},
	{
		pk: '8a665d18-e54b-4099-9792-dbcec394dcf2',
		name: 'Liver Chestnut',
	},
	{
		pk: '7ac48d64-0cba-4b22-8825-9ddc3343199e',
		name: 'Other',
	},
	{
		pk: '13b55c9f-8083-4042-aa1f-3ee96e5e62ed',
		name: 'Overo',
	},
	{
		pk: '0d744797-7102-42c7-b018-08a792e22f14',
		name: 'Palomino',
	},
	{
		pk: '25fa6070-4a44-489d-b137-c47253cfc7b9',
		name: 'Piebald',
	},
	{
		pk: '3cf91736-d786-47db-a837-10de3f966fa0',
		name: 'Pearl',
	},
	{
		pk: '50bef2fe-f3b7-4010-8217-fb234e3f7a44',
		name: 'Perlino',
	},
	{
		pk: '79c5bac8-f56d-4819-b887-ee56f211a274',
		name: 'Pinto',
	},
	{
		pk: 'df42808e-8967-4a71-8d7c-6ef776553fd5',
		name: 'Red Chocolate',
	},
	{
		pk: 'd5447d17-976c-4b95-90f3-7a080bdec493',
		name: 'Red Dun',
	},
	{
		pk: 'dbcea0b6-69a8-4827-b327-895123da5724',
		name: 'Red Roan',
	},
	{
		pk: 'eed381f0-d943-4fb2-8ecc-30c87ca517a1',
		name: 'Roan',
	},
	{
		pk: '92b91cf7-bc82-4815-9eb6-1ecff6edb89f',
		name: 'Sabino',
	},
	{
		pk: '4ced4628-33cb-4c82-ae6d-49ae492f6416',
		name: 'Silver',
	},
	{
		pk: 'a1fbdf6e-465a-4714-b4de-512903e15223',
		name: 'Silver Dapple',
	},
	{
		pk: '19807d8a-9286-4ed6-9f04-7d6cf1c303eb',
		name: 'Smokey Black',
	},
	{
		pk: 'd509320b-05be-499d-9ce9-3401140015f7',
		name: 'Smokey Cream',
	},
	{
		pk: 'bf0c2c16-e323-4450-a0c8-2823559baa2d',
		name: 'Sorrel',
	},
	{
		pk: '34b74c48-8872-48e2-abc7-4222461231f5',
		name: 'Sorrel Overo',
	},
	{
		pk: '39f269d1-e1e6-4b17-9ff0-27ab75a966a0',
		name: 'Tobiano',
	},
	{
		pk: 'ef4344f3-fccc-4a81-995e-cc76fa927f24',
		name: 'Tovero',
	},
	{
		pk: 'bf4b6b1b-9a43-4b6e-b355-6ede2fd9ae68',
		name: 'Unknown',
	},
	{
		pk: '9c2a8e91-4094-4c86-ac1b-f17ca9a486ce',
		name: 'White',
	},
];

export const tackCategoryList = [
	{
		pk: 'e8db92e4-f4a6-4e8f-9d2f-0a56c0715226',
		name: 'Misc',
		children: [],
	},
	{
		pk: 'e7ce8a73-1ff6-4414-8e4b-ac3ed47c6f13',
		name: 'Driving',
		children: [
			{
				pk: 'b5ef5079-6068-48d6-b4f1-1d3b06334d0f',
				name: 'Carts',
				children: [],
			},
			{
				pk: 'b5e8cd70-c898-4ec5-addd-4a476cad3e8e',
				name: 'Harness',
				children: [],
			},
			{
				pk: '91c5f79d-6c94-4890-b8ab-e4da9d86b22d',
				name: 'Carriages',
				children: [],
			},
			{
				pk: '86aee038-e7b3-4845-8e20-964c1b410a25',
				name: 'Sleighs',
				children: [],
			},
			{
				pk: '6d9d645a-df67-4200-8cf8-de7dc996d21a',
				name: 'Buggies',
				children: [],
			},
			{
				pk: '3d0b3bcb-4058-4b99-b4fd-6da1c7c97a7e',
				name: 'Wagons',
				children: [],
			},
		],
	},
	{
		pk: 'e63f5bbf-aa94-42bb-a79a-a4439c6c0584',
		name: 'Saddles',
		children: [
			{
				pk: '4128c692-ae1d-4796-8946-de48d2c9bb88',
				name: 'Western',
				children: [
					{
						pk: 'fc9d2a9b-7d50-40f0-b434-d69239c37653',
						name: 'Show',
						children: [],
					},
					{
						pk: 'a65e683c-5fae-4cb8-984e-cfa8aecd1089',
						name: 'Cowhorse',
						children: [],
					},
					{
						pk: '923cd27a-e02a-4b1e-9df7-e9a146b20b88',
						name: 'Trail',
						children: [],
					},
					{
						pk: '8b0e871e-30a9-40c8-b03f-c8013e2b1b35',
						name: 'Treeless',
						children: [],
					},
					{
						pk: '7c09629f-2985-47c6-bb24-a81c7c2c75d5',
						name: 'Reining',
						children: [],
					},
					{
						pk: '678b0c77-de44-44e3-81de-4b2b875a2e0c',
						name: 'All Around',
						children: [],
					},
					{
						pk: '5efa2355-4e3e-4e54-b781-a0fc4adbba71',
						name: 'Barrel Racing',
						children: [],
					},
					{
						pk: '5906a04b-a9c9-4e93-9249-3d7a3b65d035',
						name: 'Roping',
						children: [],
					},
					{
						pk: '3db36849-f582-4e4f-9af2-f8823a556e18',
						name: 'Cutting',
						children: [],
					},
					{
						pk: '0ae73015-56f3-4642-b883-317de0ce64a8',
						name: 'Ranch',
						children: [],
					},
				],
			},
			{
				pk: 'c89d5064-2f7c-4c9e-83b1-3b8b5945d7f3',
				name: 'English',
				children: [
					{
						pk: 'ef582ae0-23a9-4778-a05b-157f4ad76e7f',
						name: 'Hunter-Jumper',
						children: [],
					},
					{
						pk: 'dc566e78-38d4-4675-a6df-0ba49402d445',
						name: 'Dressage',
						children: [],
					},
					{
						pk: '846b8076-b8e3-4aa9-a5c8-39ea8c379b29',
						name: 'All Purpose',
						children: [],
					},
					{
						pk: '03cc71f5-811c-401e-8adf-a68555f46bfd',
						name: 'Treeless',
						children: [],
					},
				],
			},
			{
				pk: '99340fc5-0bad-4f8b-a40c-38d28221f6d6',
				name: 'Australian',
				children: [],
			},
			{
				pk: '324c69fc-8df9-446a-b4c8-ebce12cf9e08',
				name: 'Endurance',
				children: [],
			},
			{
				pk: '02d9c056-c705-4f56-b69f-cfd5067113c6',
				name: 'Gaited',
				children: [],
			},
		],
	},
	{
		pk: 'c90dd991-a02b-4111-9046-d01b9cfc26a6',
		name: 'Bits',
		children: [
			{
				pk: '183a20a1-f158-4e43-9a10-aaef83d71026',
				name: 'English',
				children: [],
			},
			{
				pk: '0f61f010-9c20-427c-8bc5-81a8a5d302a6',
				name: 'Western',
				children: [],
			},
		],
	},
	{
		pk: '6a1af9f5-94eb-4199-a825-26beee38b0f6',
		name: 'Riding Apparel & Show Clothes',
		children: [
			{
				pk: '9175e074-00c2-4502-82e4-0317ef190bbc',
				name: 'Show',
				children: [
					{
						pk: '1f5b1363-4318-4af6-b46b-cc447e54fc4f',
						name: 'English',
						children: [
							{
								pk: 'f4797a17-9183-4cc9-82a6-0d84b07a147f',
								name: 'Coats',
								children: [],
							},
							{
								pk: 'c7b12f00-6891-4592-bf03-48637e0773d7',
								name: 'Helmets',
								children: [],
							},
							{
								pk: '7f7e47f7-f3ee-4e4a-a893-e304b4b9f8cd',
								name: 'Breeches',
								children: [],
							},
							{
								pk: '71e8778f-1a79-4e9b-a3ea-b6a26b8c1c9c',
								name: 'Boots',
								children: [],
							},
						],
					},
					{
						pk: 'baba604e-ea8b-4193-8e51-28bd482f56a4',
						name: 'Western',
						children: [
							{
								pk: 'fc392252-0500-4544-a156-a83944c77a1c',
								name: 'Chaps',
								children: [],
							},
							{
								pk: 'ef14bc01-7b12-4710-8aea-79471da159a1',
								name: 'Jackets/Blazers',
								children: [],
							},
							{
								pk: 'e2ff1a15-02c7-466c-b82a-4d2734234baf',
								name: 'Shirts/Tops',
								children: [],
							},
							{
								pk: 'b7b361b4-653b-4e09-abb6-69c92ea4f38d',
								name: 'Outfit',
								children: [],
							},
							{
								pk: 'af2f8686-5eb7-4bb4-a4ad-bd0cfd1bfe8e',
								name: 'Hats',
								children: [],
							},
							{
								pk: '7a57d44a-3ae6-45f7-b21b-ce9258c49231',
								name: 'Boots',
								children: [],
							},
							{
								pk: '4f9a030a-0f16-4dd5-a489-4e19959aed58',
								name: 'Vests',
								children: [],
							},
							{
								pk: '4a17cf5e-79c6-4b63-9aad-d2caeb8af909',
								name: 'Pants',
								children: [],
							},
						],
					},
				],
			},
			{
				pk: 'eee9be7c-0799-484c-aa21-299d48f6dc46',
				name: 'Chaps',
				children: [],
			},
			{
				pk: '919d18fa-ee25-4555-8084-2f086556b043',
				name: 'Spurs',
				children: [],
			},
			{
				pk: '4b35ff35-5e90-4e0d-b27c-7a1ee9e719ec',
				name: 'Boots',
				children: [],
			},
		],
	},
	{
		pk: '3582b5f4-8400-4866-be63-92a0b495cdc3',
		name: 'Horse Care & Supplies',
		children: [
			{
				pk: 'cac9af67-e72e-45fb-a913-4f4cc5fce7c0',
				name: 'Blankets & Sheets',
				children: [],
			},
		],
	},
];

// export const heightList = [
//   {
//       "pk": "22.0",
//       "name": "22.0 hh"
//   },
//   {
//       "pk": "21.3",
//       "name": "21.3 hh"
//   },
//   {
//       "pk": "21.2",
//       "name": "21.2 hh"
//   },
//   {
//       "pk": "21.1",
//       "name": "21.1 hh"
//   },
//   {
//       "pk": "21.0",
//       "name": "21.0 hh"
//   },
//   {
//       "pk": "20.3",
//       "name": "20.3 hh"
//   },
//   {
//       "pk": "20.2",
//       "name": "20.2 hh"
//   },
//   {
//       "pk": "20.1",
//       "name": "20.1 hh"
//   },
//   {
//       "pk": "20.0",
//       "name": "20.0 hh"
//   },
//   {
//       "pk": "19.3",
//       "name": "19.3 hh"
//   },
//   {
//       "pk": "19.2",
//       "name": "19.2 hh"
//   },
//   {
//       "pk": "19.1",
//       "name": "19.1 hh"
//   },
//   {
//       "pk": "19.0",
//       "name": "19.0 hh"
//   },
//   {
//       "pk": "18.3",
//       "name": "18.3 hh"
//   },
//   {
//       "pk": "18.2",
//       "name": "18.2 hh"
//   },
//   {
//       "pk": "18.1",
//       "name": "18.1 hh"
//   },
//   {
//       "pk": "18.0",
//       "name": "18.0 hh"
//   },
//   {
//       "pk": "17.3",
//       "name": "17.3 hh"
//   },
//   {
//       "pk": "17.2",
//       "name": "17.2 hh"
//   },
//   {
//       "pk": "17.1",
//       "name": "17.1 hh"
//   },
//   {
//       "pk": "17.0",
//       "name": "17.0 hh"
//   },
//   {
//       "pk": "16.3",
//       "name": "16.3 hh"
//   },
//   {
//       "pk": "16.2",
//       "name": "16.2 hh"
//   },
//   {
//       "pk": "16.1",
//       "name": "16.1 hh"
//   },
//   {
//       "pk": "16.0",
//       "name": "16.0 hh"
//   },
//   {
//       "pk": "15.3",
//       "name": "15.3 hh"
//   },
//   {
//       "pk": "15.2",
//       "name": "15.2 hh"
//   },
//   {
//       "pk": "15.1",
//       "name": "15.1 hh"
//   },
//   {
//       "pk": "15.0",
//       "name": "15.0 hh"
//   },
//   {
//       "pk": "14.3",
//       "name": "14.3 hh"
//   },
//   {
//       "pk": "14.2",
//       "name": "14.2 hh"
//   },
//   {
//       "pk": "14.1",
//       "name": "14.1 hh"
//   },
//   {
//       "pk": "14.0",
//       "name": "14.0 hh"
//   },
//   {
//       "pk": "13.3",
//       "name": "13.3 hh"
//   },
//   {
//       "pk": "13.2",
//       "name": "13.2 hh"
//   },
//   {
//       "pk": "13.1",
//       "name": "13.1 hh"
//   },
//   {
//       "pk": "13.0",
//       "name": "13.0 hh"
//   },
//   {
//       "pk": "12.3",
//       "name": "12.3 hh"
//   },
//   {
//       "pk": "12.2",
//       "name": "12.2 hh"
//   },
//   {
//       "pk": "12.1",
//       "name": "12.1 hh"
//   },
//   {
//       "pk": "12.0",
//       "name": "12.0 hh"
//   },
//   {
//       "pk": "11.3",
//       "name": "11.3 hh"
//   },
//   {
//       "pk": "11.2",
//       "name": "11.2 hh"
//   },
//   {
//       "pk": "11.1",
//       "name": "11.1 hh"
//   },
//   {
//       "pk": "11.0",
//       "name": "11.0 hh"
//   },
//   {
//       "pk": "10.3",
//       "name": "10.3 hh"
//   },
//   {
//       "pk": "10.2",
//       "name": "10.2 hh"
//   },
//   {
//       "pk": "10.1",
//       "name": "10.1 hh"
//   },
//   {
//       "pk": "10.0",
//       "name": "10.0 hh"
//   },
//   {
//       "pk": "9.3",
//       "name": "9.3 hh"
//   },
//   {
//       "pk": "9.2",
//       "name": "9.2 hh"
//   },
//   {
//       "pk": "9.1",
//       "name": "9.1 hh"
//   },
//   {
//       "pk": "9.0",
//       "name": "9.0 hh"
//   },
//   {
//       "pk": "8.3",
//       "name": "8.3 hh"
//   },
//   {
//       "pk": "8.2",
//       "name": "8.2 hh"
//   },
//   {
//       "pk": "8.1",
//       "name": "8.1 hh"
//   },
//   {
//       "pk": "8.0",
//       "name": "8.0 hh"
//   },
//   {
//       "pk": "7.3",
//       "name": "7.3 hh"
//   },
//   {
//       "pk": "7.2",
//       "name": "7.2 hh"
//   },
//   {
//       "pk": "7.1",
//       "name": "7.1 hh"
//   },
//   {
//       "pk": "7.0",
//       "name": "7.0 hh"
//   },
//   {
//       "pk": "6.3",
//       "name": "6.3 hh"
//   },
//   {
//       "pk": "6.2",
//       "name": "6.2 hh"
//   },
//   {
//       "pk": "6.1",
//       "name": "6.1 hh"
//   },
//   {
//       "pk": "6.0",
//       "name": "6.0 hh"
//   },
//   {
//       "pk": "5.3",
//       "name": "5.3 hh"
//   },
//   {
//       "pk": "5.2",
//       "name": "5.2 hh"
//   },
//   {
//       "pk": "5.1",
//       "name": "5.1 hh"
//   },
//   {
//       "pk": "5.0",
//       "name": "5.0 hh"
//   }
// ];
export const heightList = [
	{ pk: '5.0', value: 5.0, name: '5.0 hh' },
	{ pk: '5.1', value: 5.1, name: '5.1 hh' },
	{ pk: '5.2', value: 5.2, name: '5.2 hh' },
	{ pk: '5.3', value: 5.3, name: '5.3 hh' },
	{ pk: '6.0', value: 6.0, name: '6.0 hh' },
	{ pk: '6.1', value: 6.1, name: '6.1 hh' },
	{ pk: '6.2', value: 6.2, name: '6.2 hh' },
	{ pk: '6.3', value: 6.3, name: '6.3 hh' },
	{ pk: '7.0', value: 7.0, name: '7.0 hh' },
	{ pk: '7.1', value: 7.1, name: '7.1 hh' },
	{ pk: '7.2', value: 7.2, name: '7.2 hh' },
	{ pk: '7.3', value: 7.3, name: '7.3 hh' },
	{ pk: '8.0', value: 8.0, name: '8.0 hh' },
	{ pk: '8.1', value: 8.1, name: '8.1 hh' },
	{ pk: '8.2', value: 8.2, name: '8.2 hh' },
	{ pk: '8.3', value: 8.3, name: '8.3 hh' },
	{ pk: '9.0', value: 9.0, name: '9.0 hh' },
	{ pk: '9.1', value: 9.1, name: '9.1 hh' },
	{ pk: '9.2', value: 9.2, name: '9.2 hh' },
	{ pk: '9.3', value: 9.3, name: '9.3 hh' },
	{ pk: '10.0', value: 10.0, name: '10.0 hh' },
	{ pk: '10.1', value: 10.1, name: '10.1 hh' },
	{ pk: '10.2', value: 10.2, name: '10.2 hh' },
	{ pk: '10.3', value: 10.3, name: '10.3 hh' },
	{ pk: '11.0', value: 11.0, name: '11.0 hh' },
	{ pk: '11.1', value: 11.1, name: '11.1 hh' },
	{ pk: '11.2', value: 11.2, name: '11.2 hh' },
	{ pk: '11.3', value: 11.3, name: '11.3 hh' },
	{ pk: '12.0', value: 12.0, name: '12.0 hh' },
	{ pk: '12.1', value: 12.1, name: '12.1 hh' },
	{ pk: '12.2', value: 12.2, name: '12.2 hh' },
	{ pk: '12.3', value: 12.3, name: '12.3 hh' },
	{ pk: '13.0', value: 13.0, name: '13.0 hh' },
	{ pk: '13.1', value: 13.1, name: '13.1 hh' },
	{ pk: '13.2', value: 13.2, name: '13.2 hh' },
	{ pk: '13.3', value: 13.3, name: '13.3 hh' },
	{ pk: '14.0', value: 14.0, name: '14.0 hh' },
	{ pk: '14.1', value: 14.1, name: '14.1 hh' },
	{ pk: '14.2', value: 14.2, name: '14.2 hh' },
	{ pk: '14.3', value: 14.3, name: '14.3 hh' },
	{ pk: '15.0', value: 15.0, name: '15.0 hh' },
	{ pk: '15.1', value: 15.1, name: '15.1 hh' },
	{ pk: '15.2', value: 15.2, name: '15.2 hh' },
	{ pk: '15.3', value: 15.3, name: '15.3 hh' },
	{ pk: '16.0', value: 16.0, name: '16.0 hh' },
	{ pk: '16.1', value: 16.1, name: '16.1 hh' },
	{ pk: '16.2', value: 16.2, name: '16.2 hh' },
	{ pk: '16.3', value: 16.3, name: '16.3 hh' },
	{ pk: '17.0', value: 17.0, name: '17.0 hh' },
	{ pk: '17.1', value: 17.1, name: '17.1 hh' },
	{ pk: '17.2', value: 17.2, name: '17.2 hh' },
	{ pk: '17.3', value: 17.3, name: '17.3 hh' },
	{ pk: '18.0', value: 18.0, name: '18.0 hh' },
	{ pk: '18.1', value: 18.1, name: '18.1 hh' },
	{ pk: '18.2', value: 18.2, name: '18.2 hh' },
	{ pk: '18.3', value: 18.3, name: '18.3 hh' },
	{ pk: '19.0', value: 19.0, name: '19.0 hh' },
	{ pk: '19.1', value: 19.1, name: '19.1 hh' },
	{ pk: '19.2', value: 19.2, name: '19.2 hh' },
	{ pk: '19.3', value: 19.3, name: '19.3 hh' },
	{ pk: '20.0', value: 20.0, name: '20.0 hh' },
	{ pk: '20.1', value: 20.1, name: '20.1 hh' },
	{ pk: '20.2', value: 20.2, name: '20.2 hh' },
	{ pk: '20.3', value: 20.3, name: '20.3 hh' },
	{ pk: '21.0', value: 21.0, name: '21.0 hh' },
	{ pk: '21.1', value: 21.1, name: '21.1 hh' },
	{ pk: '21.2', value: 21.2, name: '21.2 hh' },
	{ pk: '21.3', value: 21.3, name: '21.3 hh' },
	{ pk: '22.0', value: 22.0, name: '22.0 hh' },
];

export const skillsList = [
	{
		pk: '1b6b9bbd-488f-461a-9dca-4ddd1dfa2dfc',
		name: '4-H',
	},
	{
		pk: '1ffd0ba6-6d62-41f6-9288-8c02cace92bf',
		name: 'Advanced Rider Recommended',
	},
	{
		pk: 'b5420616-11a9-4d92-bfd7-481dd399c628',
		name: 'All-Around',
	},
	{
		pk: '8749caa7-47d9-4194-8370-efe5bbe520cd',
		name: 'All-Around Prospect',
	},
	{
		pk: '811a9cf4-c082-49ac-ac5b-efa3180697c8',
		name: 'Baroque Horse',
	},
	{
		pk: 'f29f3d30-1327-4624-b86b-3ddb67328158',
		name: 'Barrel Racing',
	},
	{
		pk: '9772bcf4-da84-4cb0-81d1-0bc18b15146b',
		name: 'Barrel Racing (Prospect)',
	},
	{
		pk: '1dcd0a47-7d25-4502-9fc5-b64855da6ae1',
		name: 'Beginner-Safe Horse',
	},
	{
		pk: '2b2e2f39-11c0-4316-ad01-674b90cf76a3',
		name: 'Breeders Trust',
	},
	{
		pk: '62ef3169-4e3c-4d34-8eaa-36e5e5ea5a93',
		name: 'Bridle Horse',
	},
	{
		pk: '77323d84-d495-452c-9db3-4ff8f7324782',
		name: 'Broodmare',
	},
	{
		pk: 'c5d7cd7d-f316-4190-8158-e273a1cbd2f8',
		name: 'Broodmare (Prospect)',
	},
	{
		pk: 'cd18b8b3-6273-47a6-a7f5-8a775965700b',
		name: 'Broodmare Only',
	},
	{
		pk: '6a692053-ee5f-4d89-adf9-480d25461411',
		name: 'Calf Roping',
	},
	{
		pk: '68987e94-b5e7-4356-b973-4522212623ba',
		name: 'Champion',
	},
	{
		pk: 'd018d15e-39d0-41ea-93bf-82ae8dd5b4e8',
		name: 'Champion Pedigree',
	},
	{
		pk: 'ed6b0fd5-e707-4224-b687-3b5d967a12ef',
		name: 'Color Tested',
	},
	{
		pk: 'c3fe9732-4ac5-41ee-a433-223ed229e813',
		name: 'Companion Only',
	},
	{
		pk: '72c37b5b-beaa-40e2-9599-43c177a71d51',
		name: 'Country English Pleasure',
	},
	{
		pk: '08cdc626-ec82-4ca5-8c99-748b4d572202',
		name: 'Cow Horse',
	},
	{
		pk: 'c52880a3-3e47-4f49-9107-be46a0e900f7',
		name: 'Cow Horse (Prospect)',
	},
	{
		pk: '2988ce46-6936-4594-aae9-ed40f825f32d',
		name: 'Cowboy Mounted Shooting',
	},
	{
		pk: '9d8e79e4-2ee5-4f68-b585-87309169f0cd',
		name: 'Cutting',
	},
	{
		pk: 'b9c82846-de91-472c-a8b8-faab4170d2d4',
		name: 'Cutting (Prospect)',
	},
	{
		pk: 'f25a8826-db3e-49e5-bf22-2728ed612587',
		name: 'Double Registered',
	},
	{
		pk: '5ae276af-b555-41e4-ac40-5e3a80b71c3f',
		name: 'Double Registered AQHA/APHA',
	},
	{
		pk: '679752b8-bc09-48b4-bedb-a0a8c249f1ab',
		name: 'Draft',
	},
	{
		pk: '6d790f9e-7fd8-42c3-9eb8-dce5cce26efa',
		name: 'Dressage',
	},
	{
		pk: '824b69f2-7cfd-4aad-bb52-ffc60446ab01',
		name: 'Dressage (Prospect)',
	},
	{
		pk: 'a30300e5-a572-4e5a-8953-f83df50dd174',
		name: 'Drill Team',
	},
	{
		pk: 'd2f43379-6a92-4719-bb0b-649517f92d81',
		name: 'Driving',
	},
	{
		pk: '5be813e2-a52d-44f7-948b-825640367451',
		name: 'Endurance Riding',
	},
	{
		pk: 'a57cb6ff-01e6-4be5-b74c-12184dc3ec87',
		name: 'English Pleasure',
	},
	{
		pk: '19e6801b-25ec-407e-80c1-73ccb26f4ac9',
		name: 'Eventing',
	},
	{
		pk: '7b3981dd-ad38-4f8b-a844-717d07e28754',
		name: 'Field Trials',
	},
	{
		pk: '6796d38c-8ced-4baa-8c1e-23d5733ce7bb',
		name: 'Foundation-Bred',
	},
	{
		pk: '7a945b8c-b223-44a4-aee3-679e68c323f9',
		name: 'Foxhunter',
	},
	{
		pk: 'a992ff24-3453-4711-80f7-7a9d255d6d42',
		name: 'Futurity Eligible',
	},
	{
		pk: '3c460e29-ef93-4ada-bc7f-d71bd61c5ecc',
		name: 'Gun-Safe Hunting Horse',
	},
	{
		pk: '523a4e90-61dd-423d-b310-4fe71ba8cf73',
		name: 'Gymkhana',
	},
	{
		pk: '61f23482-d213-4c61-b2a9-7465ab1b12e3',
		name: 'Halter',
	},
	{
		pk: 'ba6d078a-ee0c-4b36-a593-a436050cd4aa',
		name: 'Halter (Prospect)',
	},
	{
		pk: '2478256e-42a2-493d-a137-91143d2b5e79',
		name: 'Harness',
	},
	{
		pk: '305b370e-ece2-4ecd-8ac4-ce0848010f1e',
		name: 'Harness Racing',
	},
	{
		pk: 'a1f2115f-d47c-4af8-b56e-23103eac99a8',
		name: 'Hazing',
	},
	{
		pk: '6a0125d2-4fe5-4fbd-955a-49947fe791ff',
		name: 'HERDA Negative',
	},
	{
		pk: 'ea5ab414-55bb-4d07-ba8a-06c97d169915',
		name: 'Heterozygous',
	},
	{
		pk: '30642066-57c3-4f03-b952-1e24eeff17bb',
		name: 'High Percentage Color Producer',
	},
	{
		pk: '164a8f90-ba35-4982-9acd-c8634872b58d',
		name: 'High Percentage Cropout Producer',
	},
	{
		pk: 'a5ffc619-0fcc-4184-a584-f68a865c6015',
		name: 'High Percentage Dun Factor Producer',
	},
	{
		pk: 'a0b966d7-7805-4f9e-a1fe-60a976a5728d',
		name: 'Homozygous',
	},
	{
		pk: '982da5b6-f2b2-4038-86ae-3c695db35c69',
		name: 'Homozygous Black',
	},
	{
		pk: '35c63562-dead-47ce-b907-987623ec9e90',
		name: 'Homozygous Tobiano',
	},
	{
		pk: '91a66a6a-7d2d-45bd-9f2a-280b225e1b77',
		name: 'Horse Ball',
	},
	{
		pk: '3ed4e547-3950-44ae-8340-b1cf0059fe7b',
		name: 'Horsemanship',
	},
	{
		pk: 'd6501170-a174-422f-bbf7-1584508d3df5',
		name: 'Hunt Seat Equitation',
	},
	{
		pk: '5a0d67f9-57e3-4f79-8b6d-9909ff103630',
		name: 'Hunter',
	},
	{
		pk: '581ac231-c834-417a-95ea-cc6cc036c7d1',
		name: 'Hunter Under Saddle',
	},
	{
		pk: 'cad4c636-49b8-4026-a450-552fa33a06ec',
		name: 'Husband-Safe Horse',
	},
	{
		pk: '1f79f441-64fe-4ec1-a0f1-09fe6f7e728c',
		name: 'HYPP H/H',
	},
	{
		pk: 'ccf910f8-68c2-435f-8519-ac530c943820',
		name: 'HYPP N/H',
	},
	{
		pk: '525b98c3-6edf-4b5a-b7f3-fe88a3c24f30',
		name: 'HYPP N/N',
	},
	{
		pk: '8c0ddad3-1456-4071-a34b-92650a8b85bb',
		name: 'Incentive Fund',
	},
	{
		pk: '90bf750d-2b66-4f2f-ad06-855004165d72',
		name: 'Intermediate Rider Recommended',
	},
	{
		pk: 'b98f16fd-255d-4c90-b7b8-df1eafcfcd7d',
		name: 'Jumping',
	},
	{
		pk: 'bc211ca3-fe25-4aba-8b39-981b554d5d9c',
		name: 'Kentucky Breeders Incentive Program',
	},
	{
		pk: '85e7f0c7-c1cb-4273-bf09-1968b914c456',
		name: 'Kid-Friendly Family Horse',
	},
	{
		pk: '103535f7-1213-4ef1-a343-59366337fcd7',
		name: 'Lesson Horse',
	},
	{
		pk: '22369862-ec12-426d-939a-e52a1c9f24af',
		name: 'Lesson Horse (Prospect)',
	},
	{
		pk: '19cc6fc1-9887-4b43-961c-cd45e2f01160',
		name: 'Longe Line',
	},
	{
		pk: '46bb948d-045f-464b-898e-c9e5782945b9',
		name: 'Money Winner',
	},
	{
		pk: '544dec9f-8584-4fb9-9120-e3858eb94c18',
		name: 'Mounted Games',
	},
	{
		pk: 'a7d319b1-9a95-48ae-a9c9-7a868812fc35',
		name: 'Mounted Patrol',
	},
	{
		pk: '5f79cb50-20de-4045-bec6-c6dfea2a5e9f',
		name: 'Mounted Police',
	},
	{
		pk: '1903b602-1aeb-436c-ac35-ff165afb0e4e',
		name: 'Native Costume',
	},
	{
		pk: '60dd5f84-57d0-49ff-b3dd-e7fce640d1dc',
		name: 'Natural Horsemanship Training',
	},
	{
		pk: '36a96e3c-8298-437d-b2fa-b9173cdb1b9d',
		name: 'NRBC Eligible',
	},
	{
		pk: '5ee155a8-b34a-4a39-9658-3254e01b2b8e',
		name: 'NRBC Enrolled',
	},
	{
		pk: '778e640f-3cee-468a-a26c-7b2dc94de156',
		name: 'NRCHA Subscribed Stallion',
	},
	{
		pk: '8351c97a-a1ac-43d3-8d28-41ccc81df464',
		name: 'NRHA Futurity/Derby Nominated',
	},
	{
		pk: '0c28e582-37fc-4d4e-8b8d-408dca314af5',
		name: 'NRHA Sire and Dam Program',
	},
	{
		pk: '00578ec3-12fe-458e-a57d-4ed0e3442204',
		name: 'Nurse Mare',
	},
	{
		pk: 'd979a954-673b-4c6e-a924-ed8388c68e8f',
		name: 'Orphan Foal',
	},
	{
		pk: '8b52934e-fe70-4a3b-8845-6f875eafba6d',
		name: 'Pacing Gait',
	},
	{
		pk: '7ab69b3c-d912-419a-ade4-6bbe972a9099',
		name: 'Pack Horse',
	},
	{
		pk: '7601e5db-1804-42e7-a58f-114aabb18163',
		name: 'Parades',
	},
	{
		pk: '64c3a6e3-4ddb-4078-ad21-ef6b9204ba90',
		name: 'Playday',
	},
	{
		pk: '6c05cf11-20d8-469a-9400-83de5953172c',
		name: 'Pleasure Driving',
	},
	{
		pk: '9169c59a-517e-4c17-9cd9-ea3f2228ee25',
		name: 'PMU Foal',
	},
	{
		pk: '1b3233c0-b0c3-4147-b341-3d8b7bdcff58',
		name: 'Point Earner',
	},
	{
		pk: '60197845-4c43-41b3-a5e2-7f7d06c0b2e9',
		name: 'Pole Bending',
	},
	{
		pk: '5179cbad-3fbb-4d69-9ec6-544807f9375f',
		name: 'Polo',
	},
	{
		pk: '4060dd0d-22fa-47bf-8472-1fc09cc8e781',
		name: 'Polocrosse',
	},
	{
		pk: '6a30a096-2195-4abc-bc72-47994c8a9b04',
		name: 'Pony Breed',
	},
	{
		pk: '0b8f57ba-09ed-47f6-b2e4-3ad2ac8490db',
		name: 'Pony Club',
	},
	{
		pk: 'e41f74be-6cf9-40b5-aebd-4e5362204934',
		name: 'Racing',
	},
	{
		pk: '6071918e-5595-4e72-8ad4-990c01ae10a6',
		name: 'Racing (Prospect)',
	},
	{
		pk: '19b7cb01-ad60-4b27-8934-3e4e1b5c82ab',
		name: 'Racking Gait',
	},
	{
		pk: '1dbe73fa-803f-435a-bc31-ba5a4120555d',
		name: 'Ranch Sorting',
	},
	{
		pk: '6564654d-56b1-4ccb-beb4-695d514343af',
		name: 'Ranch Versatility',
	},
	{
		pk: '774f73c9-6650-4f0c-b150-0c654273bff2',
		name: 'Ranch Versatility (Prospect)',
	},
	{
		pk: 'ef2e8102-d1ff-4b80-8011-0104747f1f5a',
		name: 'Ranch Work',
	},
	{
		pk: '84bcc646-b894-4765-9fc7-baf2d9f7efb0',
		name: 'Ranch Work (Prospect)',
	},
	{
		pk: 'de31a90c-e7e2-4a8d-9c55-b3b97a1f14ac',
		name: 'Recipient Broodmare',
	},
	{
		pk: '24f0e9e6-2368-4a1a-86e2-c923db8cd0e6',
		name: 'Register of Merit',
	},
	{
		pk: '01b8fd14-6850-4321-9467-da3f7899ac91',
		name: 'Reining',
	},
	{
		pk: '0ce3e9ac-8a88-4458-af9c-2194b3f217c5',
		name: 'Reining (Prospect)',
	},
	{
		pk: '9945b9ab-f5e9-4626-9f28-794c26c89b4f',
		name: 'Reining/Cow Horse/Cutting Prospect',
	},
	{
		pk: '27001edc-59d3-41f1-9189-5b0b84107b88',
		name: 'Rescue Horse',
	},
	{
		pk: 'f842ddb1-cb2e-446d-9c73-b719e48a84c4',
		name: 'Ridden English',
	},
	{
		pk: 'c3f71205-ef4b-41a5-b6f0-c41933d6be56',
		name: 'Ridden Western',
	},
	{
		pk: '8f54773f-1dc4-434b-8fa7-90d2735a4029',
		name: 'Rodeo Pickup Horse',
	},
	{
		pk: 'a29e8397-14e3-49e4-ad8d-f155cb563c69',
		name: 'Rodeo Queen Horse',
	},
	{
		pk: '10227b7d-d7c3-40a7-9101-9d7d64278eaa',
		name: 'Rodeo Saddle/Bareback Bronc',
	},
	{
		pk: 'cca4a20b-aaf4-413f-b50e-e83ed414803a',
		name: 'Roping (Prospect)',
	},
	{
		pk: '8a50c05f-d772-447b-9ed1-d274e1231bf7',
		name: 'Roping - All-Around',
	},
	{
		pk: '5a1ea377-2835-46a0-a39c-2251ef0e0b8f',
		name: 'Saddle Seat',
	},
	{
		pk: '5a69a92c-3eeb-4369-8989-7214aead2618',
		name: 'School',
	},
	{
		pk: 'f9500397-1f4f-4cfd-8b89-f462e63005af',
		name: 'Show Experience',
	},
	{
		pk: '66572519-add7-4664-a6e9-8343cf0f8e80',
		name: 'Show Hack',
	},
	{
		pk: 'a506460a-ca60-4c89-8155-708cbe2e605b',
		name: 'Show Winner',
	},
	{
		pk: 'f5d67426-10d6-4348-b537-2cb475ac95cf',
		name: 'Showmanship at Halter',
	},
	{
		pk: '9fa6ccb0-13f4-4d28-ae19-8d8af9fba724',
		name: 'Sidesaddle',
	},
	{
		pk: '1e3df279-83c2-43e5-8d95-d1aecc3679fc',
		name: 'Sporthorse',
	},
	{
		pk: 'dc42cdaa-f15d-4277-9d83-0eca1a5544fb',
		name: 'Stallion Prospect',
	},
	{
		pk: '98012936-5dcd-4fc4-8f1f-86c24a384ea1',
		name: 'Stallion/Breeding',
	},
	{
		pk: '5ece41c2-fcde-42b2-8b91-76b71bbfd15f',
		name: 'Started Under Saddle',
	},
	{
		pk: 'e69205a9-396e-43be-ba4a-addbe70e5846',
		name: 'Steer Roping',
	},
	{
		pk: '62cbb8d3-17de-48f5-a1f1-6622b1056294',
		name: 'Steer Wrestling',
	},
	{
		pk: '0c7fe867-e39c-4c55-ab7c-2d71dda356c0',
		name: 'Superior Award',
	},
	{
		pk: 'c38b022e-97ae-47d0-bfa3-dad1ceaf3d27',
		name: 'Team Driving',
	},
	{
		pk: 'fad12efc-e0ab-4e3c-b010-6662fd561403',
		name: 'Team Penning',
	},
	{
		pk: '615334c7-45e3-4358-a98e-bebdfa2b323b',
		name: 'Team Penning (Prospect)',
	},
	{
		pk: '2b311985-0140-4b12-8d6c-b4cea792c229',
		name: 'Team Roping',
	},
	{
		pk: '86ac60e8-dbb2-4040-a9f4-3f4f8f14c4cc',
		name: 'Team Roping Head Horse',
	},
	{
		pk: '162bc4ca-d7c5-40fd-be75-a4c1c853a64a',
		name: 'Team Roping Heel Horse',
	},
	{
		pk: '4bb2dc33-dedf-44e1-ad9b-ce08edfa9191',
		name: 'Therapeutic Riding',
	},
	{
		pk: 'e133af2f-b350-4df7-8c6a-140cea977307',
		name: 'Three-In-One Package',
	},
	{
		pk: '39acfe4d-ea4a-46f8-af66-32b128f621dd',
		name: 'Trail Class Competition',
	},
	{
		pk: '74206fcb-ab0d-4f84-a4a2-6cb04ef37491',
		name: 'Trail Riding:Competitve',
	},
	{
		pk: '7ac5902a-b518-44b7-a64e-1a2fe0a8f23f',
		name: 'Trail Riding:Recreational',
	},
	{
		pk: '9e3ef883-d583-4963-a276-ada47df1df2b',
		name: 'Trick Horse',
	},
	{
		pk: '78480504-f556-46e1-9b72-2e916fe4ffe0',
		name: 'Triple Registered',
	},
	{
		pk: 'b8423715-e59f-4ece-bb76-6a512eb920ca',
		name: 'Two-In-One Package',
	},
	{
		pk: '3434b736-7119-46f4-9de4-1d0fa20f4597',
		name: 'Vaulting',
	},
	{
		pk: '0662410c-2b36-4273-bfe1-6f9d28bb1444',
		name: 'Weanling',
	},
	{
		pk: '02245779-ac03-43ac-b452-ad5430fed2e3',
		name: 'Western Pleasure',
	},
	{
		pk: 'aa992f7a-b7b1-49ae-8731-ed8a9a3ff740',
		name: 'Western Pleasure (Prospect)',
	},
	{
		pk: '250d3201-1787-4b2b-a741-e9e34be8dfc1',
		name: 'Western Riding',
	},
	{
		pk: '07ae7bb2-0dce-4c42-b743-60c7d0ed2343',
		name: 'Wife-Safe Horse',
	},
	{
		pk: '9b7ac83e-71be-4fcc-9516-27d3eed053ce',
		name: 'Yearling',
	},
	{
		pk: '8c5d460c-6d34-40c2-8db7-2c07326e4378',
		name: 'Youth',
	},
];
/*
export const skillsList = [
  {"pk":"26","name":"4-H"},
  {"pk":"154","name":"Advanced Rider Recommended"},
  {"pk":"33","name":"All-Around"},
  {"pk":"131","name":"All-Around Prospect"},
  {"pk":"155","name":"Baroque Horse"},
  {"pk":"1","name":"Barrel Racing"},
  {"pk":"96","name":"Barrel Racing (Prospect)"},
  {"pk":"152","name":"Beginner-Safe Horse"},
  {"pk":"83","name":"Breeders Trust"},
  {"pk":"160","name":"Bridle Horse"},
  {"pk":"31","name":"Broodmare"},
  {"pk":"97","name":"Broodmare (Prospect)"},
  {"pk":"56","name":"Broodmare Only"},
  {"pk":"2","name":"Calf Roping"},
  {"pk":"92","name":"Champion"},
  {"pk":"66","name":"Champion Pedigree"},
  {"pk":"147","name":"Color Tested"},
  {"pk":"28","name":"Companion Only"},
  {"pk":"73","name":"Country English Pleasure"},
  {"pk":"47","name":"Cow Horse"},
  {"pk":"108","name":"Cow Horse (Prospect)"},
  {"pk":"128","name":"Cowboy Mounted Shooting"},
  {"pk":"3","name":"Cutting"},
  {"pk":"98","name":"Cutting (Prospect)"},
  {"pk":"113","name":"Double Registered"},
  {"pk":"112","name":"Double Registered AQHA\/APHA"},
  {"pk":"4","name":"Draft"},
  {"pk":"5","name":"Dressage"},
  {"pk":"99","name":"Dressage (Prospect)"},
  {"pk":"120","name":"Drill Team"},
  {"pk":"6","name":"Driving"},
  {"pk":"7","name":"Endurance Riding"},
  {"pk":"75","name":"English Pleasure"},
  {"pk":"8","name":"Eventing"},
  {"pk":"132","name":"Field Trials"},
  {"pk":"64","name":"Foundation-Bred"},
  {"pk":"65","name":"Foxhunter"},
  {"pk":"84","name":"Futurity Eligible"},
  {"pk":"125","name":"Gun-Safe Hunting Horse"},
  {"pk":"85","name":"Gymkhana"},
  {"pk":"9","name":"Halter"},
  {"pk":"101","name":"Halter (Prospect)"},
  {"pk":"10","name":"Harness"},
  {"pk":"157","name":"Harness Racing"},
  {"pk":"41","name":"Hazing"},
  {"pk":"142","name":"HERDA Negative"},
  {"pk":"149","name":"Heterozygous"},
  {"pk":"49","name":"High Percentage Color Producer"},
  {"pk":"115","name":"High Percentage Cropout Producer"},
  {"pk":"50","name":"High Percentage Dun Factor Producer"},
  {"pk":"148","name":"Homozygous"},
  {"pk":"51","name":"Homozygous Black"},
  {"pk":"52","name":"Homozygous Tobiano"},
  {"pk":"137","name":"Horse Ball"},
  {"pk":"81","name":"Horsemanship"},
  {"pk":"122","name":"Hunt Seat Equitation"},
  {"pk":"11","name":"Hunter"},
  {"pk":"46","name":"Hunter Under Saddle"},
  {"pk":"118","name":"Husband-Safe Horse"},
  {"pk":"87","name":"HYPP H\/H"},
  {"pk":"86","name":"HYPP N\/H"},
  {"pk":"68","name":"HYPP N\/N"},
  {"pk":"82","name":"Incentive Fund"},
  {"pk":"153","name":"Intermediate Rider Recommended"},
  {"pk":"12","name":"Jumping"},
  {"pk":"138","name":"Kentucky Breeders Incentive Program"},
  {"pk":"57","name":"Kid-Friendly Family Horse"},
  {"pk":"38","name":"Lesson Horse"},
  {"pk":"102","name":"Lesson Horse (Prospect)"},
  {"pk":"53","name":"Longe Line"},
  {"pk":"94","name":"Money Winner"},
  {"pk":"144","name":"Mounted Games"},
  {"pk":"62","name":"Mounted Patrol"},
  {"pk":"159","name":"Mounted Police"},
  {"pk":"74","name":"Native Costume"},
  {"pk":"67","name":"Natural Horsemanship Training"},
  {"pk":"124","name":"NRBC Eligible"},
  {"pk":"123","name":"NRBC Enrolled"},
  {"pk":"140","name":"NRCHA Subscribed Stallion"},
  {"pk":"146","name":"NRHA Futurity\/Derby Nominated"},
  {"pk":"145","name":"NRHA Sire and Dam Program"},
  {"pk":"126","name":"Nurse Mare"},
  {"pk":"127","name":"Orphan Foal"},
  {"pk":"158","name":"Pacing Gait"},
  {"pk":"37","name":"Pack Horse"},
  {"pk":"63","name":"Parades"},
  {"pk":"35","name":"Playday"},
  {"pk":"13","name":"Pleasure Driving"},
  {"pk":"80","name":"PMU Foal"},
  {"pk":"93","name":"Point Earner"},
  {"pk":"14","name":"Pole Bending"},
  {"pk":"15","name":"Polo"},
  {"pk":"16","name":"Polocrosse"},
  {"pk":"119","name":"Pony Breed"},
  {"pk":"27","name":"Pony Club"},
  {"pk":"17","name":"Racing"},
  {"pk":"104","name":"Racing (Prospect)"},
  {"pk":"156","name":"Racking Gait"},
  {"pk":"77","name":"Ranch Sorting"},
  {"pk":"58","name":"Ranch Versatility"},
  {"pk":"103","name":"Ranch Versatility (Prospect)"},
  {"pk":"36","name":"Ranch Work"},
  {"pk":"105","name":"Ranch Work (Prospect)"},
  {"pk":"134","name":"Recipient Broodmare"},
  {"pk":"91","name":"Register of Merit"},
  {"pk":"18","name":"Reining"},
  {"pk":"95","name":"Reining (Prospect)"},
  {"pk":"129","name":"Reining\/Cow Horse\/Cutting Prospect"},
  {"pk":"111","name":"Rescue Horse"},
  {"pk":"55","name":"Ridden English"},
  {"pk":"54","name":"Ridden Western"},
  {"pk":"45","name":"Rodeo Pickup Horse"},
  {"pk":"121","name":"Rodeo Queen Horse"},
  {"pk":"135","name":"Rodeo Saddle\/Bareback Bronc"},
  {"pk":"100","name":"Roping (Prospect)"},
  {"pk":"42","name":"Roping - All-Around"},
  {"pk":"39","name":"Saddle Seat"},
  {"pk":"30","name":"School"},
  {"pk":"88","name":"Show Experience"},
  {"pk":"76","name":"Show Hack"},
  {"pk":"90","name":"Show Winner"},
  {"pk":"48","name":"Showmanship at Halter"},
  {"pk":"70","name":"Sidesaddle"},
  {"pk":"69","name":"Sporthorse"},
  {"pk":"130","name":"Stallion Prospect"},
  {"pk":"32","name":"Stallion\/Breeding"},
  {"pk":"89","name":"Started Under Saddle"},
  {"pk":"19","name":"Steer Roping"},
  {"pk":"20","name":"Steer Wrestling"},
  {"pk":"139","name":"Superior Award"},
  {"pk":"72","name":"Team Driving"},
  {"pk":"21","name":"Team Penning"},
  {"pk":"106","name":"Team Penning (Prospect)"},
  {"pk":"22","name":"Team Roping"},
  {"pk":"59","name":"Team Roping Head Horse"},
  {"pk":"60","name":"Team Roping Heel Horse"},
  {"pk":"136","name":"Therapeutic Riding"},
  {"pk":"78","name":"Three-In-One Package"},
  {"pk":"40","name":"Trail Class Competition"},
  {"pk":"133","name":"Trail Riding:Competitve"},
  {"pk":"23","name":"Trail Riding:Recreational"},
  {"pk":"43","name":"Trick Horse"},
  {"pk":"114","name":"Triple Registered"},
  {"pk":"79","name":"Two-In-One Package"},
  {"pk":"44","name":"Vaulting"},
  {"pk":"116","name":"Weanling"},
  {"pk":"24","name":"Western Pleasure"},
  {"pk":"107","name":"Western Pleasure (Prospect)"},
  {"pk":"25","name":"Western Riding"},
  {"pk":"151","name":"Wife-Safe Horse"},
  {"pk":"117","name":"Yearling"},
  {"pk":"29","name":"Youth"}
];*/
